import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ChevronDown, ArrowRight, LayoutDashboard, Users, Package, Inbox, FileText, ScrollText, Cog, Bot, FileSignature, Mountain, Link2, Heart,
  FileCheck2, BookOpen, Megaphone, Calculator, Wallet, Handshake, KeyRound, Sparkles, ShoppingBag, Shield, HeartPulse, PackageOpen, HandHeart,
  Briefcase, Home, Stethoscope, Store, Landmark, Eraser } from "lucide-react";

// Voci riservate all'Amministratore: l'Operatore non le vede e non può aprirle.
export const ADMIN_ONLY_PATHS = ["/admin/api-integrazione", "/admin/audit", "/admin/impostazioni", "/admin/novita"];

const P = (label, to, icon, desc, extra = {}) => ({ label, to, icon, desc, ...extra });

export const ADMIN_MENUS = [
  { key: "trattative", label: "Trattative", icon: ShoppingBag, color: "#0E8C84", desc: "Trattative, richieste, preventivi e adesioni da seguire ogni giorno.", groups: [{ items: [
    P("Trattative", "/admin/trattative", ShoppingBag, "Trattative dei Partner con i clienti ed esito della proposta unica."),
    P("Richieste", "/admin/richieste", Inbox, "Richieste di preventivo arrivate da landing e clienti."),
    P("Preventivi", "/admin/preventivi", FileText, "Tutte le pratiche: valutazione, emissione, bonifici."),
    P("Adesioni", "/admin/adesioni", FileCheck2, "Moduli di adesione da verificare.", { badge: true }),
    P("Richieste CAT NAT", "/admin/cat-nat", Mountain, "Richieste e pratiche Catastrofali."),
  ] }] },
  { key: "partner", label: "Partner", icon: Users, color: "#2A62A0", desc: "La rete dei Partner: profili, prodotti abilitati e provvigioni.", groups: [{ items: [
    P("Partner", "/admin/partner", Users, "Anagrafica Partner, dashboard, prodotti abilitati e novità."),
    P("Provvigioni", "/admin/provvigioni", Wallet, "Provvigioni maturate e pagamenti ai Partner."),
  ] }] },
  { key: "rete", label: "Rete Solidale", icon: Handshake, color: "#5E9732", desc: "Convenzioni con cooperative ed enti e vetrina pubblica.", groups: [{ items: [
    P("Accordi di Maggior Favore", "/admin/accordi", Handshake, "Accordi, landing, prodotti e sconti, verifiche del diritto."),
    P("Convenzioni", "/admin/rete-solidale", Handshake, "Convenzioni, cooperative in vetrina e lead Rete Solidale."),
    P("Vetrina cooperative", null, Store, "Pagina pubblica delle cooperative convenzionate.", { href: "/cooperative-convenzionate" }),
  ] }] },
  { key: "link", label: "Link e Landing", icon: Megaphone, color: "#E53935", desc: "Link da inviare ai clienti e landing page dei Partner.", groups: [{ items: [
    P("Link cliente", "/admin/link-cliente", Link2, "Link personalizzati da inviare ai clienti."),
    P("Landing", "/admin/landing", Megaphone, "Landing page dei Partner e moduli di richiesta."),
  ] }] },
  { key: "prodotti", label: "Prodotti", icon: Package, color: "#F39200", desc: "Soluzioni Eticapro, mondo CAT, Linea Persona e configurazione tariffe.", wide: true, groups: [
    { title: "Soluzioni Eticapro", items: [
      P("RC Economia Solidale", "/admin/quota/nuovo", Shield, "RCT/RCO per ETS, cooperative e associazioni."),
      P("Infortuni Economia Solidale", "/admin/quota/infortuni", HeartPulse, "Soci, volontari e lavoratori."),
      P("Danni ai Beni", "/admin/quota/multirischi", PackageOpen, "Sedi e beni dell'ente."),
      P("Multirischi del Volontariato", "/admin/quota/mrv", HandHeart, "Organizzazioni di volontariato."),
      P("Cat Nat", "/admin/quota/catnat", Mountain, "Catastrofali per le imprese."),
    ] },
    { title: "Altri mondo CAT", items: [
      P("D&O", "/admin/quota/do", Briefcase, "RC amministratori e consiglieri: preventivo indicativo per la Direzione."),
      P("Cauzioni", null, Landmark, "Non attive per ora.", { soon: true }),
    ] },
    { title: "Linea Persona", items: [
      P("Eticapro Soluzione Service", "/admin/formula-service", Calculator, "Formula Service, Infortuni Assimoco."),
      P("Eticapro Soluzione Self", "/admin/formula-self", Heart, "Calcolatore Formula Self (Protezione Famiglia); la pagina pubblica resta per i clienti."),
      P("Casa", "/admin/quota/casa", Home, "Abitazione e famiglia."),
    ] },
    { title: "Cooperazione Salute", items: [P("Cooperazione Salute 4You", "/admin/quota/cooperazione-salute", Stethoscope, "Piani sanitari 4You: calcolo e Assistente AI.")] },
    { title: "Configurazione", items: [
      P("Product Factory", "/admin/prodotti", Package, "Schede, documenti e regole dei prodotti."),
      P("Tassi CAT NAT", "/admin/catnat-tassi", Mountain, "Tabelle tassi Catastrofali."),
    ] },
  ] },
  { key: "strumenti", label: "Strumenti", icon: Sparkles, color: "#1B2380", plain: true, desc: "Assistente AI, manuali, novità e impostazioni di sistema.", groups: [{ items: [
    P("Assistente", "/admin/assistente", Bot, "Assistente AI tecnico sui prodotti."),
    P("Framework", "/admin/framework-relazioni", FileSignature, "Modelli della Relazione Tecnica AI."),
    P("Manuali", "/admin/manuali", BookOpen, "Manuali e guide per i Partner."),
    P("Novità di versione", "/admin/novita", Sparkles, "Note di aggiornamento e prese visione."),
    P("API & Integrazione", "/admin/api-integrazione", KeyRound, "Token per AssieticaSuite e sistemi esterni."),
    P("Audit", "/admin/audit", ScrollText, "Registro delle operazioni."),
    P("Dati di prova", "/admin/dati-prova", Eraser, "Clienti e preventivi creati dai test: controlla e cancella."),
    P("Impostazioni", "/admin/impostazioni", Cog, "Dati Assietica, compliance e modelli."),
  ] }] },
];

export const ADMIN_RAIL = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/trattative", label: "Trattative", icon: ShoppingBag },
  { to: "/admin/prodotti", label: "Prodotti", icon: Package },
  { to: "/admin/partner", label: "Partner", icon: Users },
  { to: "/admin/preventivi", label: "Preventivi", icon: FileText },
  { to: "/admin/landing", label: "Landing", icon: Megaphone },
];

const allowed = (role, i) => role === "agency_admin" || !ADMIN_ONLY_PATHS.includes(i.to);
const descFor = (m, role) => (m.key === "strumenti" && role !== "agency_admin" ? "Assistente AI, framework delle relazioni e manuali." : m.desc);
export const menusFor = (role) => ADMIN_MENUS
  .map((m) => ({ ...m, desc: descFor(m, role), groups: m.groups.map((g) => ({ ...g, items: g.items.filter((i) => allowed(role, i)) })).filter((g) => g.items.length) }))
  .filter((m) => m.groups.length);
export const menuItems = (m) => m.groups.flatMap((g) => g.items);
export const activeCount = (m) => menuItems(m).filter((i) => !i.soon).length;
export const firstLink = (m) => menuItems(m).find((i) => i.to)?.to;

const slug = (s) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-");

export function AdminMenuItem({ item, badge, onClick, prefix = "admin-nav", rich = false }) {
  const tid = `${prefix}-${slug(item.label)}`;
  const inner = (
    <>
      <span className={rich ? "grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-sage text-forest" : ""}><item.icon className="h-4 w-4" /></span>
      <span className="min-w-0 flex-1">
        <span className="flex items-center gap-2 font-medium">{item.label}
          {item.soon && <span className="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold uppercase text-slate-500">In arrivo</span>}
          {item.badge && badge > 0 && <span data-testid={`${tid}-badge`} className="rounded-full bg-terracotta px-2 py-0.5 text-[11px] font-semibold text-white">{badge}</span>}
        </span>
        {rich && <span className="mt-0.5 block text-xs leading-snug text-muted-foreground">{item.desc}</span>}
      </span>
    </>
  );
  const cls = `flex gap-3 rounded-lg text-sm text-forest transition-colors ${rich ? "items-start p-2.5" : "items-center border-b border-border/60 py-2.5"} ${item.soon ? "cursor-default opacity-60" : "hover:bg-sage hover:text-terracotta-hover"}`;
  if (item.soon) return <div className={cls} data-testid={tid}>{inner}</div>;
  if (item.href) return <a href={item.href} target="_blank" rel="noopener noreferrer" onClick={onClick} className={cls} data-testid={tid}>{inner}</a>;
  return <NavLink to={item.to} end={item.end} onClick={onClick} className={cls} data-testid={tid}>{inner}</NavLink>;
}

function MegaPanel({ menu, badge, onClose }) {
  const cols = menu.wide ? "grid-cols-3" : "grid-cols-2";
  return (
    <div className="absolute left-0 right-0 top-full z-40 px-5 animate-in fade-in slide-in-from-top-1" data-testid={`admin-mega-${menu.key}`}>
      <div className="mx-auto flex max-w-7xl overflow-hidden rounded-b-2xl border-t-4 bg-white shadow-2xl" style={{ borderColor: menu.color }}>
        <div className={`grid flex-1 gap-x-6 gap-y-4 p-6 ${cols}`}>
          {menu.groups.map((g, k) => (
            <div key={k} className={menu.wide ? "" : "col-span-2 grid grid-cols-2 gap-x-6 gap-y-1"}>
              {g.title && <div className="mb-1 px-2.5 text-[11px] font-bold uppercase tracking-wider" style={{ color: menu.color }}>{g.title}</div>}
              {g.items.map((i) => <AdminMenuItem key={i.label} item={i} badge={badge} onClick={onClose} rich />)}
            </div>
          ))}
        </div>
        <div className="flex w-64 shrink-0 flex-col bg-forest p-6 text-white">
          <div className="text-[11px] font-bold uppercase tracking-wider text-sector-yellow">In evidenza</div>
          <div className="mt-2 font-heading text-xl font-semibold leading-tight">{menu.label}</div>
          <p className="mt-2 text-sm text-white/75">{activeCount(menu)} funzioni abilitate per te.</p>
          <p className="mt-2 text-xs text-white/60">{menu.desc}</p>
          <div className="flex-1" />
          {firstLink(menu) && <Link to={firstLink(menu)} onClick={onClose} data-testid={`admin-mega-go-${menu.key}`}
            className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-sector-yellow hover:underline">Vai all'area <ArrowRight className="h-4 w-4" /></Link>}
        </div>
      </div>
    </div>
  );
}

export function AdminTopNav({ role, badge }) {
  const [open, setOpen] = useState(null);
  const menus = menusFor(role);
  const cur = menus.find((m) => m.key === open);
  return (
    <div className="relative hidden border-t border-border/60 lg:block" onMouseLeave={() => setOpen(null)}>
      <nav className="mx-auto flex max-w-7xl items-center px-5">
        {menus.map((m) => (
          <button key={m.key} onMouseEnter={() => setOpen(m.key)} onClick={() => setOpen(open === m.key ? null : m.key)} data-testid={`admin-topnav-${m.key}`}
            className={`flex items-center gap-1.5 rounded-t-lg px-3 py-3 text-[13px] font-semibold text-forest transition-colors ${m.plain ? "ml-auto" : ""} ${open === m.key ? "bg-sage" : ""}`}>
            {!m.plain && <span className="h-2 w-2 rounded-full" style={{ background: m.color }} />}{m.label}
            {menuItems(m).some((i) => i.badge) && badge > 0 && <span className="rounded-full bg-terracotta px-1.5 text-[10px] text-white">{badge}</span>}
            <ChevronDown className="h-3.5 w-3.5" />
          </button>
        ))}
      </nav>
      {cur && <MegaPanel menu={cur} badge={badge} onClose={() => setOpen(null)} />}
    </div>
  );
}

export function AdminRail() {
  return (
    <aside className="sticky top-[113px] hidden h-[calc(100vh-113px)] w-20 shrink-0 flex-col items-center gap-1.5 border-r border-border bg-white pt-5 lg:flex" data-testid="admin-rail">
      {ADMIN_RAIL.map((n) => (
        <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-rail-${slug(n.label)}`}
          className={({ isActive }) => `flex w-16 flex-col items-center gap-1 rounded-xl py-2.5 text-[10px] font-semibold transition-colors ${isActive ? "bg-forest text-white" : "text-slate-500 hover:bg-sage hover:text-forest"}`}>
          <n.icon className="h-5 w-5" strokeWidth={1.75} />{n.label}
        </NavLink>
      ))}
    </aside>
  );
}
